import { createFileRoute, useParams } from '@tanstack/react-router';
import { z } from 'zod';

import { SessionDetailScreen } from '@/features/sessions/components/shared/SessionDetailScreen';
import { requirePermission } from '@/lib/guards';

const searchSchema = z.object({
  tab: z.enum(['notes', 'case-reports', 'feedback']).catch('notes').optional(),
});

export const Route = createFileRoute('/_staff/admin/platform/sessions/$sessionId')({
  beforeLoad: () => {
    requirePermission('session:read');
  },
  component: PlatformSessionDetailRoute,
  staticData: { crumb: 'Session' },
  validateSearch: searchSchema.parse.bind(searchSchema),
});

function PlatformSessionDetailRoute() {
  const { sessionId } = useParams({ from: '/_staff/admin/platform/sessions/$sessionId' });
  return <SessionDetailScreen sessionId={sessionId} surface="platform" />;
}
